import { useEffect, useMemo } from 'react';
import { io } from 'socket.io-client';
import { getAuthToken, getSocketBaseUrl } from './liveClassroomApi';

export default function useLiveClassroomSocket() {
  const token = getAuthToken();
  const socket = useMemo(() => io(getSocketBaseUrl(), {
    path: '/socket.io',
    autoConnect: false,
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 1000,
  }), [token]);

  useEffect(() => {
    if (token) socket.connect();
    return () => socket.disconnect();
  }, [socket, token]);

  return socket;
}
